const WORDS = ["ACA Marketplace", "Dental & Vision", "Supplemental"];

export default function Marquee() {
  const items = [...WORDS, ...WORDS];
  return (
    <section className="py-8 bg-[#1E3A2F] overflow-hidden" data-testid="marquee">
      <div className="marquee-track">
        {items.map((w, i) => (
          <span key={i} className="mx-10 font-display text-4xl md:text-5xl tracking-tight text-[#F9F6F0] inline-flex items-center gap-10">
            {w}
            <span className="text-[#C85A40]">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
